import { toWireField } from './fieldTypes';

/**
 * Ono što čarobnjak za uvoz stvarno šalje na lanac.
 *
 * Izdvojeno iz `MfDataTransmission` da bi se moglo proveriti testom: ovo je
 * poslednja tačka pre slanja, i ćutke ispusti sve što se ne prepiše. Tako je
 * `description` — koji plugin puni izvorom („Imported from MySQL clinic.patients")
 * — nestajao, pa je host padao na svoj uopšteni fallback („Imported from MySQL
 * Import"). Nije se videlo dok opis nije zatrebao za razrešavanje veza.
 */

/** Zastavice koje postoje samo zbog UI-ja i na lancu nemaju šta da traže. */
export const stripUiFieldFlags = (field) => {
    if (!field || typeof field !== "object") return field;
    const cleaned = { ...field };
    delete cleaned.new;
    if (cleaned.object && typeof cleaned.object === "object" && Array.isArray(cleaned.object.fields)) {
        cleaned.object = {
            ...cleaned.object,
            fields: cleaned.object.fields.map(toWire),
        };
    }
    return cleaned;
};

/**
 * Polje spremno za lanac: bez UI zastavica i u rečniku lanca.
 *
 * Čarobnjak govori `decimal`, lanac zna za `int64_t` uz `logical_type`. Prevod
 * na ULAZU radi `toWizardField` (`useMfImportService`), ovde je izlaz — bez oba
 * bi ista komponenta uređivala kolone u dva rečnika.
 */
const toWire = (field) => toWireField(stripUiFieldFlags(field));

/**
 * Čarobnjak drži polja u jednom nizu sa `is_index`, jer korisnik u koraku 2
 * čekira šta postaje indeks; lanac ih traži razdvojene.
 *
 * @param {object} table tabela iz `MfImportContext`
 * @param {string} name ime kompozicije
 * @param {string} permission ovlašćenje izabrano u čarobnjaku
 */
export const toComposition = (table, name, permission) => ({
    name,
    target: table.target,
    // Opis nosi izvor (šema i tabela) i jedini je trag odakle je kompozicija
    // došla. Vidi `relations.js` — po njemu se razrešava cilj stranog ključa
    // kad je kompozicija preimenovana pri uvozu.
    description: table.description,
    fields: (table.fields || []).filter((f) => !f.is_index).map(toWire),
    indexes: (table.fields || []).filter((f) => f.is_index).map(toWire),
    permission,
});
